var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook24 = function SvgBook24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9ZM8 8a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 21a1 1 0 0 1-1 1H9a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h10a1 1 0 0 1 1 1v18ZM6 7a3 3 0 0 1 3-3h9v12H6V7Zm.17 11A3.001 3.001 0 0 0 9 20h9v-2H6.17Z",
    fill: "currentColor"
  })));
};
export default SvgBook24;